angular.module('tf.controllers')

    .controller('ResetPasswordController', function ($scope, AuthService, RecaptchaService, AuthAlertService) {

                $scope.disableButton = false;
                $scope.passwordChanged = false;
                $scope.credentials = {
                    email: '',
                    password: ''
                };

                $scope.reset = function(credentials){
                    // if(credentials.password !== credentials.confirmPassword){
                    //     return AuthAlertService.alert('Passwords must match', 'danger');
                    // }
                    $scope.disableButton = true;
                    AuthService.redirectAfterLogin('null');
                    RecaptchaService.execute('reset_password').then(function(token){
                        credentials['g-recaptcha-response'] = token;
                        AuthService.resetPassword(credentials).then(function(){
                            $scope.passwordChanged = true;
                            $scope.disableButton = false;
                        },function(){
                            $scope.disableButton = false;
                        });
                    });
                };
                RecaptchaService.renderV3('reset-password-recaptcha');
    })
;
